import { useToastController } from '@tamagui/toast';
import { getErrorMessage } from './error-message';

export function useAppToast() {
  const ctrl = useToastController();
  return {
    showError: (error: unknown) =>
      ctrl.show(getErrorMessage(error), { customData: { preset: 'error' }, duration: 5000 }),
    showSuccess: (message: string) =>
      ctrl.show(message, { customData: { preset: 'success' }, duration: 3000 }),
    showInfo: (message: string) =>
      ctrl.show(message, { customData: { preset: 'info' }, duration: 3000 }),
  };
}
